module.exports = __webpack_public_path__ + "static/media/productos_agropecuaria.51dc1ce9.jpg";